import Footer from "../Common/Footer";
import Header from "../Common/Header";

import React, { useState, use, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ApiContext } from "../Context/Context";
import { useContext } from "react";
import { getRecords, PostRecords } from "../Services/ApiCall";
import FeaturedPropertiesList from "../Common/FeaturedPropertiesList";
import ProjectComp from "../Common/Projects";
import NearByProperties from "../Common/NearByProperties";
import {
  LoggedInUserID,
  LoggedInUserName,
  setLogindata,
  setUserdata,
} from "../Services/Urls";
import FilterParams from "../Classes/FilterParams";
import ProjectFilterParams from "../Classes/ProjectFilterParams";
import { useNavigate } from "react-router-dom";
import CustomSearch from "../Classes/CustomSearch";
import { tab } from "@testing-library/user-event/dist/tab";
import {
  getUserLocation,
  getWishList,
  addtoWishlist,
  getSearchData,
} from "../Services/Helper";
import { TailSpin } from "react-loader-spinner";
import LoginDialog from "../Common/LoginDialog";

function Home() {
  const {
    logindata,
    setlogindata,
    userData,
    setuserData,
    CityData,
    setCityData,
    vertical,
    setVertical,
    properType,
    setproperType,
    coordinates,
    setcoordinates,
    BHKData,
    setBHKData,
    Locality,
    setLocality,
    Area,
    setArea,
    Projects,
    setProjects,
    searchData,
    setsearchData
  } = useContext(ApiContext);

  const isMobile = window.innerWidth < 768;

  const [propertyTypeID, setPropertyTypeID] = useState(1);
  const [verticalID, setVerticalID] = useState(1);
  const [tabID, setTabID] = useState(384);
  const [openLogin, setOpenLogin] = useState(false);
  const [PropertyTypeFlag, setPropertyTypeFlag] = useState(1);
     const [selectedItems, setSelectedItems] = useState([]);

  const [openn, setOpenn] = useState(false);

  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(false);
  const panelRef = useRef(null);

  const navigate = useNavigate();
  const [FeaturedProperties, setFeaturedProperties] = useState([]);
  const [ProjectsNoida, setProjectsNoida] = useState([]);
  const [City, setCity] = useState({
    _id: 1,
    StateID: 1,
    Country: "India",
    CountryID: 1,
    City: "Noida",
    StateCode: "09",
    State: "Uttar Pradesh",
    CityAlias: "Gautam Buddha Nagar",
    CityID: 497,
    cDt: "",
  });
  // const [searchData, setsearchData] = useState([]);
  const [nearByProperties, setnearByProperties] = useState([]);
  const [filteredResults, setFilteredResults] = useState([]);
 // selected chips/tags
  const [ChooseProperty, setChooseProperty] = useState([]);
  const [Selected_ChooseProperty, setSelectedChooseProperty] = useState([]);
  const [Loading, setLoading] = useState(true);

  useEffect(() => {
    const storedCoordinates = localStorage.getItem("coordinates");
    if (storedCoordinates) {
      const coords = JSON.parse(storedCoordinates);
      setcoordinates(coords);
      // setcoordinates(coords);

      getFeaturedProperties(coords);
      getnearByProperties(coords);
      getProjects(coords);

      if (searchData?.length === 0) {
        getSearchData(
          searchData,
          setsearchData,
          CityData,
          setCityData,
          Locality,
          setLocality,
          Area,
          setArea,
          Projects,
          setProjects,
        );
      }
      setLoading(false);
    } else {
      getUserLocation(
        (coords) => {
          console.log("Latitude:", coords.latitude);
          console.log("Longitude:", coords.longitude);
          localStorage.setItem("coordinates", JSON.stringify(coords));

          setcoordinates(coords);

          getFeaturedProperties(coords);
          getnearByProperties(coords);
          getProjects(coords);

          if (searchData?.length === 0) {
            getSearchData(
              searchData,
              setsearchData,
              CityData,
              setCityData,
              Locality,
              setLocality,
              Area,
              setArea,
              Projects,
              setProjects,
              coords,
            );
          }
          setLoading(false);
        },
        (err) => {
          console.error("Location error:", err);
          getFeaturedProperties();
          getnearByProperties(null);
          getProjects();

          if (searchData?.length === 0) {
            getSearchData(
              searchData,
              setsearchData,
              CityData,
              setCityData,
              Locality,
              setLocality,
              Area,
              setArea,
              Projects,
              setProjects,
            );
          }
          setLoading(false);
        },
      );
    }

    //search panel
    const handleClickOutside = (e) => {
      if (panelRef.current && !panelRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    getChoosePropertyType();
  }, [PropertyTypeFlag]);

  const getFeaturedProperties = (coordinates = null) => {
    const filter =
      coordinates != null
        ? `{FeaturedID: { $in: [${1}] },StatusID: { $in: [${2}] },'Coordinates': {'\$nearSphere': {'\$geometry': {'type':'Point','coordinates':[${coordinates?.longitude}, ${coordinates?.latitude}]}, '\$maxDistance': 30000000}}}`
        : `{FeaturedID: { $in: [${1}] },StatusID: { $in: [${2}] }}`;

    getRecords(384, 6, filter, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false) {
          setFeaturedProperties(data?.response?.records || []);
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getnearByProperties = (coordinates = null) => {
    const filter =
      coordinates != null
        ? `{StatusID: { $in: [${2}] },'Coordinates': {'\$nearSphere': {'\$geometry': {'type':'Point','coordinates':[${coordinates?.longitude}, ${coordinates?.latitude}]}, '\$maxDistance': 30000000}}}`
        : "{StatusID: { $in: [${2}] }}";
    getRecords(384, 10, filter, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false) {
          // setnearByProperties(data?.response?.records);

          setnearByProperties(data?.response?.records || []);
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getProjects = (coordinates = null) => {
    const filter =
      coordinates != null
        ? `{FeaturedID: { $in: [${1}] },StatusID: { $in: [${2}] },CityID: { $in: [${City.CityID}] },'Coordinate': {'\$nearSphere': {'\$geometry': {'type':'Point','coordinates':[${coordinates?.longitude}, ${coordinates?.latitude}]}, '\$maxDistance': 30000000}}}`
        : `{FeaturedID: { $in: [${1}] },StatusID: { $in: [${2}] },CityID: { $in: [${City.CityID}] }}`;

    getRecords(398, 8, filter, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false) {
          setProjectsNoida(data?.response?.records);
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getChoosePropertyType = () => {
    getRecords(
      411,
      100,
      `{PropertyTypeID: { $in: [${propertyTypeID}] },VerticalID: { $in: [${verticalID}] }}`,
      1,
      "",
      (data) => {
        if (data != null) {
          if (data?.hasErrors === false) {
            setChooseProperty(data?.response?.records);
          } else {
            console.log("Error in fetching featured properties", data);
          }
        }
      },
    );
  };

  const handleViewAll = (type) => {
    if (type === 1) {
      const filters = new FilterParams({
        propertyType: 1,
        vertical: 1,
        featured: 1,
        status: 2,
      });

      navigate("/view-all-listing?tabID=384", {
        state: {
          filters: filters,
        },
      });
    } else if (type === 2) {
      const filters = new ProjectFilterParams({
        cityIds: [City?.CityID],
        status: 2,
      });
      navigate(`/view-all-projects`, {
        state: {
          flag: 1,
          filters: filters,
        },
      });
    }
  };

  //console.log("searchData in Home:", searchData);

  const getFilteredSuggestions = (
    all,
    selected,
    searchText,
    maxResults = 12,
    respectHierarchy = true,
  ) => {
    const selectedCityIds = new Set(
      selected
        .filter((i) => i.flag === 1)
        .map((i) => i.CityID)
        .filter(Boolean),
    );

    const selectedLocalityIds = new Set(
      selected
        .filter((i) => i.flag === 2)
        .map((i) => i.LocalityID)
        .filter(Boolean),
    );

    const selectedSocietyIds = new Set(
      selected
        .filter((i) => i.flag === 3)
        .map((i) => i.SocietyID)
        .filter(Boolean),
    );

    const selectedAreaIds = new Set(
      selected
        .filter((i) => i.flag === 4)
        .map((i) => i.AreaID)
        .filter(Boolean),
    );

    const matchesName = (item) =>
      item.ResultName?.toLowerCase().includes(searchText.toLowerCase());

    const matchesHierarchy = (item) => {
      if (!respectHierarchy) return true;

      if (
        selectedCityIds.size === 0 &&
        selectedLocalityIds.size === 0 &&
        selectedAreaIds.size === 0 &&
        selectedSocietyIds.size === 0
      ) {
        return true;
      }

      // ----- City constraint -----
      const cityOk =
        selectedCityIds.size > 0
          ? item.CityID != null && selectedCityIds.has(item.CityID)
          : true;

      // ----- Locality constraint -----
      let localityOk = true;
      switch (item.flag) {
        case 2: // Locality
          localityOk = cityOk;
          break;

        case 3: // Society
        case 4: // Area
          if (selectedLocalityIds.size > 0) {
            localityOk =
              item.LocalityID != null &&
              selectedLocalityIds.has(item.LocalityID);
          }
          break;

        default:
          localityOk = true;
      }

      // ----- Area constraint -----
      const areaOk =
        selectedAreaIds.size > 0
          ? item.AreaID != null && selectedAreaIds.has(item.AreaID)
          : true;

      return cityOk && localityOk && areaOk;
    };

    return all
      .filter((item) => {
        const alreadySelected = selected.some(
          (sel) => sel.flag === item.flag && sel.ResultID === item.ResultID,
        );

        if (alreadySelected) return false;

        return matchesHierarchy(item) && matchesName(item);
      })
      .slice(0, maxResults);
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setQuery(value);

    if (value.trim().length === 0) {
      setFilteredResults([]);
      setOpen(false);
      return;
    }

    const results = getFilteredSuggestions(
      searchData, // all data
      selectedItems, // selected filters
      value, // search text
      12, // max results
      true, // respect hierarchy
    );

    setFilteredResults(results);
    setOpen(true);
  };

  const handleSearch = (e, query = "") => {
    // debugger
    e.preventDefault();

    if (PropertyTypeFlag === 5) {
      const filters = new ProjectFilterParams({
        cityIds: selectedItems
          .filter((item) => item.flag === 1)
          .map((item) => item.CityID),
        localityIds: selectedItems
          .filter((item) => item.flag === 2)
          .map((item) => item.LocalityID),
        areaIds: selectedItems
          .filter((item) => item.flag === 4)
          .map((item) => item.AreaID),
        societyIds: selectedItems
          .filter((item) => item.flag === 3)
          .map((item) => item.SocietyID),
        status: 2,
      });
      navigate(`/view-all-projects`, {
        state: {
          flag: 1,
          filters: filters,
        },
      });
    } else {
      let filters = new FilterParams({});

      if (selectedItems?.length === 0 && query != "") {
        const filtered = searchData?.filter(
          (item) =>
            item?.ResultName?.trim().toLowerCase() ===
            query?.trim()?.toLowerCase(),
        );

        setSelectedItems(filtered);

        filters = new FilterParams({
          cityIds: filtered
            .filter((item) => item.flag === 1)
            .map((item) => item.CityID),
          localityIds: filtered
            .filter((item) => item.flag === 2)
            .map((item) => item.LocalityID),
          areaIds: filtered
            .filter((item) => item.flag === 4)
            .map((item) => item.AreaID),
          societyIds: filtered
            .filter((item) => item.flag === 3)
            .map((item) => item.SocietyID),

          propertyType: propertyTypeID,
          vertical: verticalID,
          status: 2,
          propertyTypeIds: Selected_ChooseProperty.map(
            (item) => item?.ChoosePropertyID,
          ),
        });

        // console.log("setting selectedItems",selectedItems , searchData, query)
      } else 
        {
        filters = new FilterParams({
          cityIds: selectedItems
            .filter((item) => item.flag === 1)
            .map((item) => item.CityID),
          localityIds: selectedItems
            .filter((item) => item.flag === 2)
            .map((item) => item.LocalityID),
          areaIds: selectedItems
            .filter((item) => item.flag === 4)
            .map((item) => item.AreaID),
          societyIds: selectedItems
            .filter((item) => item.flag === 3)
            .map((item) => item.SocietyID),

          propertyType: propertyTypeID,
          vertical: verticalID,
          status: 2,
          propertyTypeIds: Selected_ChooseProperty.map(
            (item) => item?.ChoosePropertyID,
          ),
        });
      }

      navigate(`/view-all-listing?tabID=${tabID}`, {
        state: {
          filters: filters,
          selectedItems: selectedItems,
        },
      });
    }
  };
  const handleType = (type) => {
    if (type === 1) {
      setPropertyTypeID(1);
      setVerticalID(1);
      setTabID(384);
      setPropertyTypeFlag(1);
    } else if (type === 2) {
      setPropertyTypeID(1);
      setVerticalID(2);
      setTabID(385);
      setPropertyTypeFlag(2);
    } else if (type === 3) {
      setPropertyTypeID(2);
      setVerticalID(1);
      setTabID(387);
      setPropertyTypeFlag(3);
    } else if (type === 4) {
      setPropertyTypeID(1);
      setVerticalID(3);
      setTabID(386);
      setPropertyTypeFlag(4);
    } else if (type === 5) {
      setPropertyTypeFlag(5);
      setOpenn(false);
    }

    // getChoosePropertyType();
  };

  const handleChoosePropertyChange = (item, checked) => {
    setSelectedChooseProperty(
      (prev) =>
        checked
          ? [...prev, item] // add
          : prev.filter((p) => p.ChoosePropertyID !== item.ChoosePropertyID), // remove
    );
  };

  const [chips, setChips] = useState([
    "Property 1",
    "Property 2",
    "Property 3",
    "Property 4",
    "Property 5",
  ]);

  const removeChip = (chipToRemove) => {
    setSelectedItems(
      selectedItems?.filter(
        (chip) => chip?.ResultName !== chipToRemove?.ResultName,
      ),
    );
  };

  return (
    <>
      <div className="page-wrapper">
        <Header displaySearch={false} />
        {/* Hero section start */}
        {/* Hero section start */}
        <section className="hero-wrap style3">
          <div className="hero-slider-two "></div>
          <div className="hero-content">
            <div className="row">
              <div className="col-xxl-10 offset-xxl-1 col-xl-10 offset-xl-1 col-lg-10 offset-lg-1">
                <h1
                  data-aos="fade-up"
                  data-aos-duration={1200}
                  data-aos-delay={200}
                >
                  Find Your Dream Property
                  <div style={{ color: "#059669" }}>In Your Dream City</div>
                </h1>
                <p
                  data-aos="fade-up"
                  data-aos-duration={1200}
                  data-aos-delay={300}
                >
                  Search across thousands of verified listings from trusted
                  agents and builders
                </p>

                <div className="property-search">
                  <ul className="nav nav-tabs property-tablist" role="tablist">
                    <li className="nav-item">
                      <button
                        onClick={() => handleType(1)}
                        className="nav-link active"
                        data-bs-toggle="tab"
                        type="button"
                        role="tab"
                      >
                        Buy
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        onClick={() => handleType(2)}
                        className="nav-link"
                        data-bs-toggle="tab"
                        type="button"
                      >
                        Rent
                      </button>
                    </li>
                    {/* <li className="nav-item d-none d-md-block">
                      <button
                        onClick={() => handleType(3)}
                        className="nav-link"
                        data-bs-toggle="tab"
                        type="button"
                      >
                        Commercial
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        onClick={() => handleType(4)}
                        className="nav-link"
                        data-bs-toggle="tab"
                        type="button"
                      >
                        PG
                      </button>
                    </li> */}
                    <li className="nav-item">
                      <button
                        onClick={() => handleType(5)}
                        className="nav-link"
                        data-bs-toggle="tab"
                        type="button"
                      >
                        New Projects
                      </button>
                    </li>
                  </ul>

                  <form
                    action="#"
                    className="property-search-form"
                    data-aos="fade-up"
                    data-aos-duration={1200}
                    data-aos-delay={400}
                  >
                    <div className="form-group-wrap">
                      <div className="form-group">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="searchbloc">
                              <i class="ri-map-pin-line absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-lg w-5 h-5 flex items-center justify-center"></i>
                              <div
                                style={{
                                  position: "relative",
                                  width: "100%",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                                ref={panelRef}
                              >
                                <input
                                  className="inpts"
                                  type="text"
                                  value={query}
                                  onChange={handleChange}
                                  placeholder="Enter city, locality, or project name"
                                />

                                {open && (
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: "100%",
                                      left: 0,
                                      right: 0,
                                      background: "#fff",
                                      border: "1px solid #ddd",
                                      padding: "10px",
                                      zIndex: 10,
                                      boxShadow:
                                        "0 3px 5px -1px #0003,0 6px 10px #00000024,0 1px 18px #0000001f",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        gap: "8px",
                                        flexWrap: "wrap",
                                        marginBottom: 10,
                                      }}
                                    >
                                      {selectedItems?.map((chip, i) => (
                                        <div
                                          key={i}
                                          style={{
                                            padding: "6px 12px",
                                            borderRadius: "16px",
                                            background: "#e0e0e0",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                          }}
                                        >
                                          {chip?.ResultName}
                                          <span
                                            onClick={() => removeChip(chip)}
                                            style={{
                                              cursor: "pointer",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            ×
                                          </span>
                                        </div>
                                      ))}
                                    </div>
                                    <ul className="searchlistt">
                                      {filteredResults?.length === 0 && (
                                        <>
                                          <li>
                                            Can you please specify the city?
                                          </li>

                                          {searchData
                                            ?.filter((item) => item?.flag == 1)
                                            ?.slice(0, 5)
                                            ?.map((item, index) => (
                                              <li
                                                key={index}
                                                onClick={() => {
                                                  // setQuery(item.ResultName);
                                                  // setOpen(false);
                                                  setSelectedItems((prev) => {
                                                    if (
                                                      prev.some(
                                                        (i) =>
                                                          i?.ResultName ===
                                                          item?.ResultName,
                                                      )
                                                    ) {
                                                      return prev;
                                                    }
                                                    return [...prev, item];
                                                  });
                                                }}
                                              >
                                                <span>{item.ResultName}</span>{" "}
                                                <span>
                                                  {item.flag == 1
                                                    ? "City"
                                                    : item.flag == 2
                                                      ? "Locality"
                                                      : item.flag == 3
                                                        ? "Project"
                                                        : "Area"}
                                                </span>
                                              </li>
                                            ))}
                                        </>
                                      )}
                                      {filteredResults?.map((item, index) => (
                                        <li
                                          key={index}
                                          onClick={() => {
                                            // setQuery(item.ResultName);
                                            // setOpen(false);
                                            setSelectedItems((prev) => {
                                              if (
                                                prev.some(
                                                  (i) =>
                                                    i?.ResultName ===
                                                    item?.ResultName,
                                                )
                                              ) {
                                                return prev;
                                              }
                                              return [...prev, item];
                                            });
                                          }}
                                        >
                                          <span>{item.ResultName}</span>{" "}
                                          <span>
                                            {item.flag == 1
                                              ? "City"
                                              : item.flag == 2
                                                ? "Locality"
                                                : item.flag == 3
                                                  ? "Project"
                                                  : "Area"}
                                          </span>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            {PropertyTypeFlag !== 5 && (
                              <div className="ress searchselectbox">
                                <div
                                  onClick={() => setOpenn(!openn)}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    width: "-webkit-fill-available",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      width: "-webkit-fill-available",
                                      alignItems: "center",
                                    }}
                                  >
                                    <i
                                      class="ri-home-4-line text-gray-400 text-lg w-5 h-5 flex items-center justify-center"
                                      style={{ marginRight: 10 }}
                                    ></i>

                                    <div>
                                      {PropertyTypeFlag == 1 ||
                                      PropertyTypeFlag == 2
                                        ? "All Residential"
                                        : PropertyTypeFlag == 3
                                          ? "All Commercial"
                                          : PropertyTypeFlag == 4
                                            ? "All PG"
                                            : "All Projects"}{" "}
                                    </div>
                                  </div>

                                  <div
                                    style={{
                                      textAlign: "right",
                                      display: "inline-block",
                                    }}
                                  >
                                    {" "}
                                    {openn ? "▲" : "▼"}
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="col-md-2">
                            <button
                              type=""
                               disabled={(!query || filteredResults?.length == 0) &&  (!query || ( selectedItems?.length == 0))}
                              onClick={(e) => {
                                handleSearch(e, query);
                              }}
                              className="btn style2"
                              style={{ width: "100%", height: "89%" }}
                            >
                              <i class="ri-search-2-line menuline mline"></i>
                              <span className="">Search</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                {openn && (
                  <div style={{ height: 150 }} className="expcontent">
                    <div className="row">
                      <div className="col-md-12">
                        <ul
                          className="checklist"
                          style={{
                            display: "grid",

                            width: "100%",
                            gap: "6px",
                          }}
                        >
                          {ChooseProperty?.map((item) => (
                            <li key={item?.ChoosePropertyID}>
                              <input
                                type="checkbox"
                                id={`property-${item.ChoosePropertyID}`}
                                checked={Selected_ChooseProperty.some(
                                  (p) =>
                                    p.ChoosePropertyID ===
                                    item.ChoosePropertyID,
                                )}
                                onChange={(e) =>
                                  handleChoosePropertyChange(
                                    item,
                                    e.target.checked,
                                  )
                                }
                              />
                              <label
                                htmlFor={`property-${item.ChoosePropertyID}`}
                              >
                                {item?.ChooseProperty}
                              </label>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
        {/* Hero section end */}

        {/* Property section start */}
        <section className="property-wrap ptb-100">
          <div className="container">
            <div className="row section-title style1 mb-40  align-items-end">
              <div className="col-md-8">
                <h2>Featured Properties</h2>
              </div>
              <div className="col-md-4 text-md-end sm-none">
                <text onClick={() => handleViewAll(1)} className="btn style6">
                  View All
                </text>
              </div>
            </div>
            <div className="property-slider-two">
              <div className="row" style={{ justifyContent: "flex-start" }}>
                {FeaturedProperties?.map((item, index) => (
                  <FeaturedPropertiesList
                    key={index}
                    {...item}
                    onheartClick={() => setOpenLogin(true)}
                  />
                ))}
              </div>
            </div>
          </div>
        </section>
        {/* Property section end */}

        {/* Property section start */}
        <section className="property-wrap pt-100 pb-75 bg-seashell">
          <div className="container">
            <div className="row section-title style1 mb-40  align-items-end">
              <div className="col-md-8">
                <h2>New Projects in {City?.City}</h2>
              </div>
              <div className="col-md-4 text-md-end sm-none">
                <text onClick={() => handleViewAll(2)} className="btn style6">
                  View All
                </text>
              </div>
            </div>
            <ul className="nav nav-tabs property-tablist" role="tablist">
              <li className="nav-item">
                <button
                  className="nav-link active"
                  data-bs-toggle="tab"
                  data-bs-target="#tab_1"
                  type="button"
                  role="tab"
                >
                  Show All
                </button>
              </li>
              <li className="nav-item">
                <button
                  className="nav-link"
                  data-bs-toggle="tab"
                  data-bs-target="#tab_1"
                  type="button"
                  role="tab"
                >
                  RERA Verified
                </button>
              </li>
            </ul>
            <div className="tab-content hw-tab-content">
              <div
                className="tab-pane fade show active"
                id="tab_1"
                role="tabpanel"
              >
                <div className="row">
                  {ProjectsNoida?.map((item, index) => (
                    <ProjectComp
                      key={index}
                      {...item}
                      onheartClick={() => setOpenLogin(true)}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Property section end */}
        {/* Property Slider start */}
        <section className="property-slider-wrap pt-100 pb-75">
          <div className="container">
            <div className="row">
              <div className="col-xl-12 offset-xl-12 col-lg-12">
                <div className="section-title style1 mb-40">
                  <h3>Nearby Properties</h3>
                </div>
              </div>
            </div>
            <div className="row">
              {nearByProperties?.map((item, index) => (
                <NearByProperties
                  key={index}
                  {...item}
                  onheartClick={() => setOpenLogin(true)}
                />
              ))}
            </div>
          </div>
        </section>
        {/* Property Slider end */}

        {/* Property Slider start
        <section className="property-slider-wrap pt-100 pb-75 services  bg-seashell">
          <div className="container">
            <div className="row section-title style1 mb-40  align-items-end">
              <div className="col-md-8">
                <h2>Our Services</h2>
              </div>
              <div className="col-md-4 text-md-end sm-none">
                <a href="#" className="btn style6">
                  View All
                </a>
              </div>
            </div>
            <div className="row d-flex df">
              <div className="property-card style3">
                <div className="property-info">
                  <div className="icons">
                    <i className="ri-file-text-line" />
                  </div>

                  <p>Rent Agreement</p>
                </div>
              </div>{" "}
              <div className="property-card style3">
                <div className="property-info">
                  <div className="icons">
                    <i className="ri-file-user-line" />
                  </div>

                  <p>Agent Finder</p>
                </div>
              </div>{" "}
              <div className="property-card style3">
                <div className="property-info">
                  <div className="icons">
                    <i className="ri-truck-line" />
                  </div>

                  <p>Movers & Packers</p>
                </div>
              </div>{" "}
              <div className="property-card style3">
                <div className="property-info">
                  <div className="icons">
                    <i className="ri-home-2-line" />
                  </div>

                  <p>Home Automation</p>
                </div>
              </div>{" "}
              <div className="property-card style3">
                <div className="property-info">
                  <div className="icons">
                    <i className="ri-palette-line" />
                  </div>

                  <p>Interior Designer</p>
                </div>
              </div>{" "}
              <div className="property-card style3">
                <div className="property-info">
                  <div className="icons">
                    <i className="ri-hammer-line" />
                  </div>

                  <p>Construction Agent</p>
                </div>
              </div>{" "}
              <div className="property-card style3">
                <div className="property-info">
                  <div className="icons">
                    <i className="ri-bank-line" />
                  </div>

                  <p>Home Loan</p>
                </div>
              </div>{" "}
              <div className="property-card style3">
                <div className="property-info">
                  <div className="icons">
                    <i className="ri-price-tag-3-line" />
                  </div>

                  <p>Request Agent Valuation</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        Property Slider end */}

        <Footer />

        <LoginDialog
          open={openLogin}
          onClose={() => setOpenLogin(false)}
          onSuccess={(data) => {
            if (data) {
              //  console.log("Login Success:", data);
              setLogindata(data);
              setlogindata(data);

              localStorage.setItem("loginData", JSON.stringify(data));
            }

            //  setUser(data);
          }}
          onUserDetails={(userDetails) => {
            if (userDetails) {
              // console.log("User Details:", userDetails);
              setUserdata(userDetails);
              setuserData(userDetails);
              localStorage.setItem("UserData", JSON.stringify(userDetails));
            }
          }}
        />

        {Loading && (
          <div
            style={{
              position: "absolute",
              inset: 0,
              backgroundColor: "rgba(255,255,255,0.7)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 10,
            }}
          >
            <TailSpin color="#00BFFF" height={80} width={80} />
          </div>
        )}
      </div>
    </>
  );
}

export default Home;
